import { Alert, Modal, ScrollArea } from "@mantine/core";
import { IconAlertCircle, IconInfoCircle } from "@tabler/icons-react";
import React from "react";
import type {
  BulkClientUploadFileError,
  BulkClientUploadRecordError,
} from "./types";

const ERROR_MODAL_TITLE =
  "We encountered some issues while processing your document. Below, you’ll find details about what went wrong. Please fix the errors and try again.";

type ErrorModalProps = {
  opened: boolean;
  onClose: () => void;
  failedRecords: BulkClientUploadRecordError[];
  existingRecords: string[];
  fileErrors: BulkClientUploadFileError[];
};

const BulkClientModalErrors: React.FC<ErrorModalProps> = ({
  opened,
  onClose,
  failedRecords,
  existingRecords,
  fileErrors,
}) => {
  return (
    <Modal
      className="client-modal"
      opened={opened}
      centered
      onClose={onClose}
      title="Errors"
      padding="lg"
      closeOnEscape
      size="lg"
    >
      {/* Error Section */}
      <div style={{ marginBottom: 10 }}>{ERROR_MODAL_TITLE}</div>

      <ScrollArea type="auto" mb="md">
        {fileErrors?.map((recordError) => (
          <Alert
            key={recordError.message}
            icon={<IconAlertCircle />}
            color="red"
            variant="outline"
            mb="sm"
          >
            {recordError.message}
          </Alert>
        ))}
        {failedRecords?.map((recordError) => (
          <Alert
            key={recordError.message}
            icon={<IconAlertCircle />}
            color="red"
            variant="outline"
            mb="sm"
          >
            The record for <strong>{recordError.email}</strong> is invalid:{" "}
            {recordError.message}
          </Alert>
        ))}

        {existingRecords?.map((record) => (
          <Alert
            key={record}
            icon={<IconInfoCircle />}
            color="yellow"
            variant="outline"
            mb="sm"
          >
            The record for <strong>{record}</strong> already exists in the
            system.
          </Alert>
        ))}
      </ScrollArea>
    </Modal>
  );
};

export default BulkClientModalErrors;
